import { render, staticRenderFns } from "./allPost.vue?vue&type=template&id=636da520&scoped=true&"
import script from "./allPost.vue?vue&type=script&lang=js&"
export * from "./allPost.vue?vue&type=script&lang=js&"
import style0 from "./allPost.vue?vue&type=style&index=0&id=636da520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636da520",
  null
  
)

export default component.exports